import { render, staticRenderFns } from "./add-remark.vue?vue&type=template&id=1b652856&scoped=true"
import script from "./add-remark.vue?vue&type=script&lang=ts"
export * from "./add-remark.vue?vue&type=script&lang=ts"
import style0 from "./add-remark.vue?vue&type=style&index=0&id=1b652856&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b652856",
  null
  
)

export default component.exports